import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText  } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom'

import { People, People2 } from '../constants/config'

import { useDispatch, useSelector } from 'react-redux';

function PeopleListDialog(props) {
    const { open, onClose } = props;

    const igonFlag = useSelector(state => state.igon.igonFlag);

    let p = false;
    if(igonFlag){
        p = People2;
    }else{
        p = People;
    }

    return(
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>編集する情報を選択してください</DialogTitle>
            <DialogContent scroll="paper">
                <List>
                    {Object.keys(p).map((key) => {
                        return (
                            <ListItem button component={RouterLink} to={key} onClick={onClose}>
                                <ListItemText primary={People2[key]}/>
                            </ListItem>
                        );
                    })}
                </List>
            </DialogContent>
        </Dialog>
    );
}

export default PeopleListDialog;
